interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-20 py-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-semibold text-[#2B2B2B] tracking-tight">
            KOLOS d.o.o.
          </h1>

          <div className="flex items-center gap-10">
            <button
              onClick={() => scrollToSection('about')}
              className="text-base font-medium text-[#5A5A5A] hover:text-[#2B2B2B] transition-colors cursor-pointer whitespace-nowrap"
            >
              About
            </button>
            <div className="w-px h-4 bg-[#5A5A5A] opacity-20"></div>
            <button
              onClick={() => scrollToSection('products')}
              className="text-base font-medium text-[#5A5A5A] hover:text-[#2B2B2B] transition-colors cursor-pointer whitespace-nowrap"
            >
              Products
            </button>
            <div className="w-px h-4 bg-[#5A5A5A] opacity-20"></div>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-base font-medium text-[#5A5A5A] hover:text-[#2B2B2B] transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact
            </button>
          </div>
        </div>
      </div>
      <div className={`h-px bg-[#2B2B2B] transition-opacity duration-300 ${isScrolled ? 'opacity-0' : 'opacity-[0.08]'}`}></div>
    </nav>
  );
}
